import { Row } from "antd";
import React from "react";
import {
  Controller,
  FieldError,
  RegisterOptions,
  useFormContext,
} from "react-hook-form";
import Checkbox from "../components/uielements/checkbox";
import ErrorInputMessage from "./ErrorInputMessage";

type Props = {
  name: string;
  label?: string;
  rules?: RegisterOptions;
  placeholder?: string;
  error?: FieldError;
  style?: any;
  type?: string;
  value?: string | number;
  children: any;
};
const CheckBoxController = ({
  name,
  error,
  label,
  rules,
  placeholder,
  style,
  value,
  ...rest
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const fieldError = error ? error : errors && errors[name];
  return (
      <Row style={{ flexDirection: "column", gap: "5px" }}>
        {label && <h4 style={{ marginBottom: 0 }}>{label}</h4>}
      <Controller
        rules={rules}
        control={control}
        name={name}
        render={({ field }) => (
          <Checkbox
            {...field}
            placeholder={placeholder ? placeholder : label?.toLowerCase()}
            style={style}
            checked={value || field.value}
            {...rest}
          >
            {rest.children}
          </Checkbox>
        )}
      />
      <ErrorInputMessage error={fieldError as any} />
    </Row>
  );
};

export default CheckBoxController;
